export default "__VITE_ASSET__C6Xs6z1P__"